<template>
  <div class="search-shoe">
    <form :action="localePath({ name: 'search' })">
      <input
        ref="searchInput"
        :value="query"
        @input="query = $event.target.value"
        @keypress="query = $event.target.value"
        v-debounce:200="onQueryChange"
        type="text"
        autocomplete="off"
        name="q"
        :placeholder="placeholder ? placeholder : $t('generic.search_placeholder')"
        @focus="activate"
        @blur="inactivate"
      />

      <ul v-if="(shoes.length > 0 || error) && active" id="search-suggestions">
        <li v-if="error" class="error">{{ $t('generic.error_try_again') }}</li>
        <li
          class="search-suggestion"
          v-for="(shoe, index) in shoes"
          :key="index"
          :class="{ 'suggestion-w-image': shoe.img }"
          @click.capture="select(shoe)"
          @mousedown.prevent
        >
          <img v-if="shoe.img" class="suggestion-image" :src="shoe.img" alt="" />
          <span class="suggestion-content" v-html="shoe.name" />
        </li>
      </ul>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    categoryId: {
      type: Number,
      default: null,
    },
    onlyShoes: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['selected', 'active', 'inactive'],
  data() {
    return {
      query: '',
      error: false,
      shoes: [],
      active: false,
    };
  },
  methods: {
    select(shoe) {
      this.$emit('selected', shoe);
    },
    activate() {
      this.active = true;
      this.$emit('active');
    },
    inactivate($event) {
      this.active = false;
      this.$emit('inactive');
    },
    async onQueryChange() {
      if (this.query?.length <= 2) {
        return;
      }
      this.shoes = await $api('/suggest.php', {
        params: {
          version: '1',
          q: this.query,
          c_id: this.categoryId,
        },
        responseType: 'json',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-shoe {
  form {
    position: relative;
    height: 56px;
    width: 100%;
    z-index: 10;
    white-space: nowrap;
    input[type='text'] {
      width: 100%;
      display: inline-block;
      height: 100%;
      vertical-align: top;
      padding: 0 20px;
      margin-right: -4px;
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
      border: 1px solid #fff;
      &:focus {
        outline: 0;
      }
    }
  }
  #search-suggestions {
    top: 60px;
    left: 0;
    position: absolute;
    background: #fff;
    border-radius: 2px;
    border: 1px solid #fff;
    width: 100%;
    list-style: none;
    padding-left: 0;
    z-index: 100;
    height: 300px;
    overflow: auto;
    li {
      cursor: pointer;
      height: 100%;
      width: 100%;
      line-height: 60px;
      padding: 0 20px;
      color: #000;
      position: relative;
      &:hover {
        text-decoration: none;
        span.suggestion-content {
          text-decoration: underline;
        }
      }
      height: 32px;
      background: #fff;
      width: 100%;
      text-align: left;
      border-top: 1px solid $grey-dark;

      span.suggestion-content {
        span.suggestion {
          //color: $grey-dark;
          color: #000;
          font-weight: 300;
          .query {
            color: #000;
          }
          .category {
            font-weight: bold;
            color: #000;
          }
        }
      }
      img.suggestion-image {
        // display: none;
        margin-right: 10px;
        max-height: 40px;
      }

      :deep() {
        svg {
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
          height: 14px;
          width: 14px;
        }
      }

      &.error {
        color: $error_text_color;
        padding: 5px;
      }
      &.suggestion-w-image {
        height: 60px;
      }
      &:first-child {
        margin-top: 5px;
        border-top: none;
      }
      &:last-of-type {
        border-bottom: none;
      }
      & + .suggestion-group-label {
        border-top: none;
      }
      &.suggestion-group-label {
        margin-top: 10px;

        span {
          height: 100%;
          width: 100%;
          line-height: 32px;
          display: inline-block;
          padding: 0 20px;
          //color: #000;
          color: $grey;
        }
      }
    }
  }
}
</style>
